import { useQuery } from '@tanstack/react-query';

import type { AIResponseActionDTO } from './AIResponseActionMatrix.types';

export const useFetchAIResponseActions = () =>
  useQuery<AIResponseActionDTO[]>({
    queryKey: ['ai_response_actions/'],
    staleTime: Infinity
  });

export default useFetchAIResponseActions;
